'use strict';
import React from 'react';
/**
 * Defines spacing for a group of Checkbox elements.
 *
 * Usage:
 *
 * ```Javascript
 * <CheckboxGroup>
 *   <Checkbox>Value1</Checkbox>
 *   <Checkbox>Value2</Checkbox>
 * </CheckboxGroup>
 * ```
 *
 * @extends {React.Compponent}
 */
class CheckboxGroup extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */

  render () {
    return (
      <div className="Checkbox">
        {this.props.children}
      </div>
    );
  }
}

CheckboxGroup.defaultProps = {
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/checkboxGroup.jsx